/*


*/
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueHead from 'vue-head'
import VueAnalytics from 'vue-analytics'
import VueMq from 'vue-mq'
import Paginate from 'vuejs-paginate'
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: {
   id: 'G-DN5QP3R6CD'
  }
}, router)

Vue.use(VueAnalytics, {
    id: 'UA-148178506-1',
    router
})

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(VueHead, { separator: '|'})
Vue.use(VueMq, {
  breakpoints: { sp: 959, pc: 960 },
  defaultBreakpoint: 'sp'
})

Vue.component('paginate', Paginate)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
